module.exports = "/images/home-2.png";